import CustomerScreenShell from "@/components/customer-screen-shell";
import SectionCard from "@buildpy/ui/section-card";

// 공개 시공사례 화면의 한 줄 안내(한도·일시 장애).
const PublicNotice = ({ text }: { text: string }) => (
  <CustomerScreenShell>
    <SectionCard as="div" className="mx-auto w-full max-w-sm p-5 text-center text-sm" padding="none" role="alert">
      {text}
    </SectionCard>
  </CustomerScreenShell>
);

export default PublicNotice;
